import { IApplicationState } from '../../types/redux';

export const selectProps = ({ props, comparison: { compareType } }: IApplicationState) => {
  return props[compareType];
};
